import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import PropTypes from 'prop-types';

const ActionButton = ({ img, alt, onClick, others, tabIndex, className }) => {
  return (
    <LazyLoadImage
      src={`/content/images/icons/${img}`}
      others={others}
      alt={alt}
      onClick={onClick}
      tabIndex={tabIndex}
      className={className}
      {...others}
    />
  );
};

ActionButton.propTypes = {
  img: PropTypes.string,
  alt: PropTypes.string,
  tabIndex: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func
};

ActionButton.defaultProps = {
  img: '',
  alt: '',
  tabIndex: '',
  className: '',
  setModal: () => {},
  others: { width: '24px', height: '24px' }
};
export default ActionButton;
